<span class="beta">EN FASE DE PRUEBAS</span>
<div class="container">
  <app-order-status-card
    *ngFor="let order of orders$ | async"
    [order]="order"
  ></app-order-status-card>
</div>
